import { ExpandMore } from "@mui/icons-material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import UpdateBtnsAccordion from "../UpdateBtnsAccordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import CBSalesArea from "./CBSalesArea";
import { isGlobalEditModeState } from "../../state/customerbaseState";
import { useRecoilValue } from "recoil";
import { CBCreationOfProps, IFormValues } from "../../types";
import { useFormContext } from "react-hook-form";
import { SyntheticEvent } from "react";
import { useTranslation } from "react-i18next";

interface CBSalesAreasAccordionProps extends CBCreationOfProps {
    isExpanded: boolean,
    index: number,
    area: any,
    onRemove: (event: SyntheticEvent, index: number) => void
}
const CBSalesAreasAccordion = ({
    creationOf,
    isExpanded,
    index,
    area,
    onRemove
}: CBSalesAreasAccordionProps) => {

    const { t } = useTranslation('customerbase');

    const isCreationMode = !!creationOf;
    
    const editing = useRecoilValue(isGlobalEditModeState);

    const { getValues } = useFormContext<IFormValues>();

    return (
        <Accordion>
            <AccordionSummary expandIcon={ <ExpandMore/>}>
                <UpdateBtnsAccordion
                        label={(isCreationMode && !getValues(`salesAreas.${index}.id`))? 
                            t("tabs.accordionsLabels.cbNewSalesArea") + (index==0? "" : (" " + (index+1))) 
                            :
                            ((!(area.salesOrganization && area.division) || !getValues(`salesAreas.${index}.id`)) ?
                                t("tabs.accordionsLabels.cbSalesAreaDetails") + (index==0? "" : (" " + (index+1)))
                                :
                                (area.salesOrganization || "") + (area.salesOrganization && area.division && " - " || "") + (area.division || null)
                            )
                        }
                    editing={!isCreationMode && editing}
                    isExpanded={isExpanded}
                    showRemove={(index > 0) && (!getValues(`salesAreas.${index}.id`)) && (isCreationMode || editing)}
                    onRemove={(event) => onRemove(event, index)}
                />
            </AccordionSummary>
            <AccordionDetails>
                <CBSalesArea 
                    index={index}
                    creationOf={creationOf} 
                />
            </AccordionDetails>
        </Accordion>

    )

}

export default CBSalesAreasAccordion;